module.exports = __webpack_public_path__ + "assets/images/coin-25-print.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/coin-25-print.png
// module id = 141
// module chunks = 1